export const defaultCurrency = { value: 'USD', label: 'United States dollar', symbol: '$' }